// actions/employee-onboarding/remove.js

import { attachAuth } from '../../utils/authService';

// remove

export function removeHasErrored(bool) {
  return {
    type: 'ONBOARDING_REMOVE_HAS_ERRORED',
    hasErrored: bool
  };
}

export function removeIsLoading(bool) {
  return {
    type: 'ONBOARDING_REMOVE_IS_LOADING',
    isLoading: bool
  };
}

export function removeFetchDataSuccess(data) {
  return {
    type: 'ONBOARDING_REMOVE_FETCH_DATA_SUCCESS',
    data
  };
}

export function removeFetchData(host, params) {
  return (dispatch) => {
    dispatch(removeIsLoading(true));
    dispatch(removeHasErrored(false));
    fetch(host + 'approve/remove', {
      method: 'post',
      body: JSON.stringify(params),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(removeFetchDataSuccess(result));
            dispatch(removeHasErrored(false));
            dispatch(removeIsLoading(false));
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(removeHasErrored(true));
            dispatch(removeIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(removeHasErrored(true));
      dispatch(removeIsLoading(false));
    });
  };
}

// removeDisplay

export function removeDisplayHasErrored(bool) {
  return {
    type: 'ONBOARDING_REMOVE_DISPLAY_HAS_ERRORED',
    hasErrored: bool
  };
}

export function removeDisplayIsLoading(bool) {
  return {
    type: 'ONBOARDING_REMOVE_DISPLAY_IS_LOADING',
    isLoading: bool
  };
}

export function removeDisplayFetchDataSuccess(data) {
  return {
    type: 'ONBOARDING_REMOVE_DISPLAY_FETCH_DATA_SUCCESS',
    data
  };
}

export function removeDisplayFetchData(host, remove) {
  return (dispatch) => {
    dispatch(removeDisplayIsLoading(true));
    dispatch(removeDisplayHasErrored(false));
    fetch(host + 'approve/removeDisplay?remove_id=' + encodeURIComponent(remove), {
      method: 'get',
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(removeDisplayFetchDataSuccess(result));
            dispatch(removeDisplayHasErrored(false));
            dispatch(removeDisplayIsLoading(false));
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(removeDisplayHasErrored(true));
            dispatch(removeDisplayIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(removeDisplayHasErrored(true));
      dispatch(removeDisplayIsLoading(false));
    });
  };
}